import { render, staticRenderFns } from "./FreightBillStatus.vue?vue&type=template&id=6e7e9396&scoped=true"
import script from "./FreightBillStatus.vue?vue&type=script&lang=js"
export * from "./FreightBillStatus.vue?vue&type=script&lang=js"
import style0 from "./FreightBillStatus.vue?vue&type=style&index=0&id=6e7e9396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e9396",
  null
  
)

export default component.exports